import { SearchOutlined } from "@ant-design/icons";
import { Icon } from "@material-ui/core";
import { Button, Input, message, notification, Space, Tag } from "antd";
import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";
import Highlighter from "react-highlight-words";
import { FaSearch } from "react-icons/fa";
import { useHistory } from "react-router";
import { urlIconeModulo, urlIconeModuloImagem } from "../../../../../services/request/urls";
import { getToken } from "../../../../../services/token";

const IconSearch = (props: any) => <Icon {...props} component={FaSearch} ></Icon>

export default function useIconeModulo() {

    const formRef = useRef<any>(null);

    const history = useHistory();

    const [selectedRowKeys, setSelectedRowKeys] = useState<Array<any>>([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [dadosTabelaState, setDadosTabelaState] = useState([]);
    const [hasSelectedAdd, setHasSelectedAdd] = useState(true);
    const [hasSelectedEdit, setHasSelectedEdit] = useState(false);
    const [hasSelectedDel, setHasSelectedDel] = useState(false);
    const [loadingFormAdd, setLoadingFormAdd] = useState(false);
    const [modalAddConfigVisible, setModalAddConfigVisible] = useState(false);
    const [icon, setIcon] = useState('');
    const [ativarOuInativarModulo, setAtivarOuInativarModulo] = useState(false);
    const [image, setImage] = useState<any>(null);
    //State de editar usuario
    const [initialValueEditId, setInitialValueEditId] = useState<undefined | number>(undefined);

    //executa apenas ao iniciar o component
    useEffect(() => {
        setLoadingTable(true);
        const buscaDeDados = async () => {
            try {
                let result = await axios.get(urlIconeModulo,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });
                setDadosTabelaState(result.data);
                setLoadingTable(false);

            } catch (error) {
                setLoadingTable(false);
                notification.error({
                    message: 'Erro',
                    description:
                        'Não foi possivel buscar os dados!',
                });
            }
        }

        buscaDeDados();

    }, []);

    //executa apenas quando salvar
    const salvarModalRecarregaTable = useCallback(() => {
        setLoadingTable(true);
        const buscaDeDados = async () => {
            try {
                let result = await axios.get(urlIconeModulo,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });
                setDadosTabelaState(result.data);
                setLoadingTable(false);

            } catch (error) {
                setLoadingTable(false);
                notification.error({
                    message: 'Erro',
                    description:
                        'Não foi possivel buscar os dados!',
                });
            }
        }

        buscaDeDados();

    }, []);

    const handleSearch = useCallback((selectedKeys, confirm, dataIndex): void => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }, []);

    const handleReset = useCallback((clearFilters): void => {
        clearFilters();
        setSearchText('');
    }, []);

    //Search da tabela de listagem
    const getColumnSearchProps = useCallback((dataIndex) => {
        let searchInput: any = '';
        return ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            searchInput = node;
                        }}
                        placeholder={`Digite...`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Pesquisar
                        </Button>
                        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                            Limpar
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: any) => filtered ? <IconSearch style={{ color: filtered ? '#1890ff' : undefined, fontSize: filtered ? 14 : undefined }} /> : <SearchOutlined />,
            onFilter: (value: any, record: any) =>
                record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
            onFilterDropdownVisibleChange: (visible: any) => {
                if (visible) {
                    setTimeout(() => searchInput.select());
                }
            },
            render: (text: any) =>
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                ) : (
                    text
                ),
        })
    }, [searchText, searchedColumn, handleReset, handleSearch]);

    const beforeUploadImage = useCallback(async (file): Promise<any> => {
        const isPng = file.type === "image/png";
        if (!isPng) {
            message.error("Somente arquivos .png são suportados!");
            return;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error("Imagem não pode ser maior que 2MB!");
            return;
        }

        formRef.current?.setFieldsValue({
            image: file,
        });

        setImage(file);
    }, []);

    const clickBotaoDeletarDados = useCallback((ativo: boolean): void => {
        const buscaDeDados = () => {
            // if (selectedRowKeys.length == 1 || selectedRowKeys.length > 1) {
            if (selectedRowKeys.length === 1) {
                let obj: Array<{ id: string }> = [];
                dadosTabelaState.forEach(({ nome, id, uuid }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid === val) {
                            obj.push({
                                id: id
                            })
                        }
                    });

                })

                const excluirDadosModal = async () => {
                    try {

                        const id = obj[0].id;

                        await axios.delete(urlIconeModulo + `/${id}`, {
                            headers: { 'Authorization': 'Bearer ' + getToken() }
                        })

                        notification.success({
                            message: 'Sucesso',
                            description:
                                `Ícone excluído com sucesso!`,
                        });
                        setLoadingFormAdd(false);
                        salvarModalRecarregaTable();
                        setInitialValueEditId(undefined);
                    } catch (error) {
                        setLoadingFormAdd(false);
                        notification.error({
                            message: 'Erro',
                            description:
                                'Não foi possivel excluir, entre em contato com suporte!',
                        });
                    }
                }
                excluirDadosModal();
                setHasSelectedAdd(true);
                setHasSelectedEdit(false);
                setHasSelectedDel(false);
                setSelectedRowKeys([]);

            }
        }

        buscaDeDados();

    }, [selectedRowKeys, dadosTabelaState, salvarModalRecarregaTable]);

    const clickCancelModalAddConfig = useCallback(() => {
        setModalAddConfigVisible(false);
        formRef.current.resetFields();
    }, []);

    const clickSubmitModalAddConfig = useCallback((): void => {
        formRef.current?.validateFields()
            .then((values: any) => {
                setLoadingFormAdd(true);

                values.image = image
                const formData = new FormData();
                formData.append('image', image);

                Object.entries(values).forEach(([key, value]: any) => {
                    if (key !== 'image' && value) {
                        formData.append(key, value);
                    }
                });
                //verifica se ele esta editando ou é um novo
                if (initialValueEditId) {
                    values.id = initialValueEditId;

                    formData.append('id', initialValueEditId.toString());

                    const editarDadosModal = async () => {
                        try {
                            await axios.put(urlIconeModulo, formData,
                                { headers: { 'Authorization': 'Bearer ' + getToken() } });
                            notification.success({
                                message: 'Sucesso',
                                description:
                                    'Seus dados foram editados com sucesso!',
                            });
                            setLoadingFormAdd(false);
                            salvarModalRecarregaTable();
                            clickCancelModalAddConfig();
                            setInitialValueEditId(undefined);
                        } catch (error: any) {
                            setLoadingFormAdd(false);
                            notification.error({
                                message: 'Erro',
                                description: error.response.data.message
                            });
                        }
                    }
                    editarDadosModal();
                } else {
                    const salvarDadosModal = async () => {
                        try {

                            await axios.post(urlIconeModulo, formData,
                                { headers: { 'Authorization': 'Bearer ' + getToken() } });
                            notification.success({
                                message: 'Sucesso',
                                description:
                                    'Seus dados foram criados com sucesso!',
                            });
                            setLoadingFormAdd(false);
                            salvarModalRecarregaTable();
                            clickCancelModalAddConfig();
                        } catch (error: any) {
                            setLoadingFormAdd(false);
                            notification.error({
                                message: 'Erro',
                                description: error.response.data.message
                            });
                        }
                    }
                    salvarDadosModal();
                }
                setHasSelectedAdd(true);
                setHasSelectedEdit(false);
                setHasSelectedDel(false);
                setSelectedRowKeys([])

            })
            .catch((errorInfo: any) => {
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });
            });
    }, [initialValueEditId, clickCancelModalAddConfig, salvarModalRecarregaTable, image]);

    //abrir modal
    const clickBotaoAdicionar = useCallback((): void => {
        setInitialValueEditId(undefined);
        setImage(null);
        setModalAddConfigVisible(true);
    }, []);

    //Editar dados
    const clickBotaoEditar = useCallback((): void => {

        const buscaDeDados = () => {

            if (selectedRowKeys.length === 1) {
                let obj: Array<any> = [];
                dadosTabelaState.forEach((objEditar: any): void => {

                    if (objEditar.uuid === selectedRowKeys[0]) {
                        obj.push(objEditar)
                    }
                })

                if (formRef.current) {
                    formRef.current.setFieldsValue(
                        {
                            nome: obj[0].nome,
                            descricao: obj[0].descricao,
                        }
                    );
                } else {
                    setTimeout(() => {
                        formRef.current?.setFieldsValue(
                            {
                                nome: obj[0].nome,
                                descricao: obj[0].descricao,
                            }
                        );
                    }, 100);
                }

                setImage(obj[0].file);
                setInitialValueEditId(obj[0].id)
                setModalAddConfigVisible(true);

            }
        }

        buscaDeDados();

        setModalAddConfigVisible(true);
    }, [selectedRowKeys, dadosTabelaState, formRef]);

    // click na linha da tabela de listagem de usuario
    const onclickTable = useCallback((record: any, row: any): void => {

        //verifica se nome esta no array
        if (selectedRowKeys.includes(record.uuid)) {
            let filter = selectedRowKeys.filter((val) => {
                return val !== record.uuid
            })
            if (filter.length === 1) {
                setSelectedRowKeys(filter);
                setHasSelectedAdd(false);
                setHasSelectedEdit(true);
                setHasSelectedDel(true);
            } else if (filter.length === 0) {
                setSelectedRowKeys(filter);
                setHasSelectedAdd(true);
                setHasSelectedEdit(false);
                setHasSelectedDel(false);
            } else {
                setSelectedRowKeys(filter);
            }

        } else {
            if (selectedRowKeys.length === 0) {
                setSelectedRowKeys([record.uuid]);
                setHasSelectedAdd(false);
                setHasSelectedEdit(true);
                setHasSelectedDel(true);
            } else {
                let teste = selectedRowKeys.concat(record.uuid);
                setSelectedRowKeys(teste);
                setHasSelectedAdd(false);
                setHasSelectedEdit(false);
                setHasSelectedDel(true);
            }
        }
    }, [selectedRowKeys]);

    //checkbox da tabela de listagem
    const onSelectChange = useCallback((rowKeys): void => {
        if (rowKeys.length > 1) {
            setSelectedRowKeys(rowKeys);
            setHasSelectedAdd(false);
            setHasSelectedEdit(false);
            setHasSelectedDel(false);
        } else if (rowKeys.length === 0) {
            setSelectedRowKeys(rowKeys);
            setHasSelectedAdd(true);
            setHasSelectedEdit(false);
            setHasSelectedDel(false);
        } else {
            setSelectedRowKeys(rowKeys);
            setHasSelectedAdd(false);
            setHasSelectedEdit(true);
            setHasSelectedDel(true);
        }
    }, [selectedRowKeys, setSelectedRowKeys]);

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: '5%'
    };

    const columns = [
        {
            title: 'Ícone',
            dataIndex: 'file',
            width: '10%',
            render: (val: any) => {
                return (
                    <img src={urlIconeModuloImagem + val} width={50} height={50} />
                )
            },
        },
        {
            title: 'Nome',
            dataIndex: 'nome',
            ...getColumnSearchProps('nome'),
            width: '20%',
        },
        {
            title: 'Descrição',
            dataIndex: 'descricao',
            ...getColumnSearchProps('descricao'),
            width: '20%',
        },

    ];

    const onChangeNome = useCallback((e: any): void => {

        //Remove maisculos e espaço trata como -
        let nomeFormatted = e.target.value.replace(/\s/g, '-').toLowerCase();

        formRef.current?.setFieldsValue({
            nome: nomeFormatted
        })
    }, []);

    const onClickVoltarConfigOfSystem = useCallback((): void => {
        history.push("/configuracoesdosistema");
    }, [history]);

    return {
        onClickVoltarConfigOfSystem,
        hasSelectedAdd,
        hasSelectedEdit,
        selectedRowKeys,
        ativarOuInativarModulo,
        clickBotaoDeletarDados,
        loadingTable,
        onclickTable,
        rowSelection,
        columns,
        dadosTabelaState,
        modalAddConfigVisible,
        clickSubmitModalAddConfig,
        clickCancelModalAddConfig,
        loadingFormAdd,
        formRef,
        icon,
        setIcon,
        image,
        beforeUploadImage,
        onChangeNome,
        clickBotaoAdicionar,
        clickBotaoEditar,
    }
}
